/*******************************************************************************
TRIGGER ALL THE CHECKBOX FILTERS ON A PAGE
Used to run the filters on page load based on their initial state (checked or unchecked).
*******************************************************************************/

import updateCheckboxFilter from './update-filter';

export default function initializeCheckBoxFilters() {

    $('.filter-checkbox').each((index, checkbox) => {
        const checkboxName = $(checkbox).data('name');
        const $items = $($(checkbox).data('items'));

        // Don't initialize the filter if the items are still loading via AJAX
        // Instead add a 'waiting-for-ajax' class and let the AJAX loader handle the initialization
        if ($items.find('.loading').length > 0 || $items.parent().find('.loading').length > 0) {
            $(checkbox).addClass('waiting-for-ajax');
            return;
        }

        updateCheckboxFilter(checkboxName);
    });

}
